import { render } from "./finishedTrainingDetail.vue?vue&type=template&id=04bb4211&scoped=true&ts=true"
import script from "./finishedTrainingDetail.vue?vue&type=script&lang=ts"
export * from "./finishedTrainingDetail.vue?vue&type=script&lang=ts"

import "./finishedTrainingDetail.vue?vue&type=style&index=0&id=04bb4211&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bb4211"]])

export default __exports__